import React from 'react'
import { Typography } from '../common/Typography'
import { CloseIcon } from './icons'

interface DialogHeaderProps {
  title: string
  icon?: React.ReactNode
  children?: React.ReactNode
  onClose: () => void
  className?: string
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  icon,
  children,
  onClose,
  className
}) => {
  return (
    <div
      className={`w-full h-[64px] relative flex items-center justify-between px-6 bg-white border-b border-[#EAEAEA] flex-shrink-0 select-none ${className ?? ''}`}
    >
      <div className='flex items-center gap-3'>
        {icon}
        <Typography
          fontFamily='geist'
          fontSize='bodySm'
          fontWeight='bold'
          style={{ color: 'rgba(0, 0, 0, 0.88)', fontSize: '14px', lineHeight: '18px' }}
        >
          {title}
        </Typography>
      </div>
      <div className='flex items-center gap-3 mr-10'>{children}</div>
      <button
        onClick={onClose}
        className='absolute top-[20px] right-[20px] flex items-center justify-center cursor-pointer'
      >
        <CloseIcon className='w-6 h-6' />
      </button>
    </div>
  )
}

export default DialogHeader
